export const STATE_SLICE_NAMES = {
  app: 'app',
  resume: 'resume',
} as const
